export default "__VITE_ASSET__CAflNGo___"